import { memo } from 'react';
import { FormControl, Select, MenuItem } from '@mui/material';
import styles from '../../publicationDetail.module.scss';

interface PublicationDealershipSelectorProps {
  type: string;
  vehicleTypeSelected: string;
  brand?: boolean;
  brandsDealerships?: any[];
  selectedDealership?: any;
  setSelectedDealership?: any;
}

const PublicationDealershipSelector = ({
  type,
  vehicleTypeSelected,
  brand,
  brandsDealerships,
  selectedDealership,
  setSelectedDealership
}: PublicationDealershipSelectorProps) => {
  // Solo mostrar si es para marcas, vehículos nuevos y no es mi publicación
  if (type === "myPublication" || vehicleTypeSelected !== "new" || !brand) {
    return null;
  }

  if (!brandsDealerships || brandsDealerships.length === 0) {
    return null;
  }

  return (
    <div className={styles.dealershipSelector}>
      <h3 className={styles.selectorTitle}>Elige tu concesionario de preferencia</h3>
      <FormControl fullWidth variant="outlined" className={styles.dealershipFormControl}>
        <Select
          value={selectedDealership || ''}
          onChange={(e) => {
            const newValue = e.target.value;
            setSelectedDealership(newValue);
          }}
          displayEmpty
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
          }}
          className={styles.dealershipSelect}
          inputProps={{
            classes: {
              icon: styles.selectIcon,
            },
          }}
        >
          <MenuItem disabled value="">
            <span className={styles.placeholder}>Concesionario</span>
          </MenuItem>
          {brandsDealerships && brandsDealerships.length > 0 ? (
            brandsDealerships.map((dealer: any) => {
              const dealerId = dealer.id || dealer._id;
              const dealerName = dealer.name || 'Concesionario';
              console.log('Renderizando concesionario:', dealerId, dealerName);
              return (
                <MenuItem key={dealerId} value={dealerId}>
                  {dealerName}
                </MenuItem>
              );
            })
          ) : (
            <MenuItem disabled>No hay concesionarios disponibles</MenuItem>
          )}
        </Select>
      </FormControl>
    </div>
  );
};

export default memo(PublicationDealershipSelector);
